
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class InventoryService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.inv_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_INVENTORY_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getSKUBatchInventoriesForRollBasedForSalesOrderOnHandQuantity(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSKUBatchInventoriesForRollBasedForSalesOrderOnHandQuantity",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAvailableSKUBatchInventoriesNotInInitialInventoryForPickTicket(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAvailableSKUBatchInventoriesNotInInitialInventoryForPickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleInventoryAdjustmentPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleInventoryAdjustmentPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createFabricStyleInventoryAdjustment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createFabricStyleInventoryAdjustment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initFabricStyleInventoryAdjustmentModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initFabricStyleInventoryAdjustmentModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelFabricStyleInventoryAdjustment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "cancelFabricStyleInventoryAdjustment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchAllWareHouseInventoryPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchAllWareHouseInventoryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getRollsForBinPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getRollsForBinPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockFabricStyleInventoryAdjustmentCode(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unLockFabricStyleInventoryAdjustmentCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchInventoryPageListWithHoldingInventory(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchInventoryPageListWithHoldingInventory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getInventoryLocationTransferPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getInventoryLocationTransferPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSKUBatchInventoriesForRollBased(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSKUBatchInventoriesForRollBased",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInventoryLocationTransfer(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createInventoryLocationTransfer",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initInventoryLocationTransferModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initInventoryLocationTransferModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockInventoryLocationTransferCode(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unLockInventoryLocationTransferCode",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createMassInventoryLocationTransfer(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createMassInventoryLocationTransfer",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchInventoryPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getSkuBatchInventoryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchInventoryTrackPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchInventoryTrackPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSKUBatchInventoriesSummary(input, responseCallBack, errorCallBack) {
    this.method(
      "getSKUBatchInventoriesSummary",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSKUInventoryResultForSKUBased(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSKUInventoryResultForSKUBased",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleInventoryData(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStyleInventoryData",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getFabricStyleInventoryForLotBased(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getFabricStyleInventoryForLotBased",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static inventoryExcelUpload(input, responseCallBack, errorCallBack) {
    this.method("inventoryExcelUpload", input, responseCallBack, errorCallBack);
  }
  static getInventoryInputFromExcel(input, responseCallBack, errorCallBack) {
    this.method(
      "getInventoryInputFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getManualInventoryCustomerAllocationPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getManualInventoryCustomerAllocationPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAllBinList(input, responseCallBack, errorCallBack) {
    this.method("getAllBinList", input, responseCallBack, errorCallBack);
  }

  static getWebSkuInventories(input, responseCallBack, errorCallBack) {
    this.method("getWebSkuInventories", input, responseCallBack, errorCallBack);
  }
  static readFabricStyleInventoryAdjustment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "readFabricStyleInventoryAdjustment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getWebSkuInventories(input, responseCallBack, errorCallBack) {
    this.method("getWebSkuInventories", input, responseCallBack, errorCallBack);
  }
  static getOpenSkuBatchInventories(input, responseCallBack, errorCallBack) {
    this.method(
      "getOpenSkuBatchInventories",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSKUBatchInventoriesBinSummary(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSKUBatchInventoriesBinSummary",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static adjustPickTicketQuantityToZero(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "adjustPickTicketQuantityToZero",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initPhysicalInventoryAdjustmentModule(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "initPhysicalInventoryAdjustmentModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createPhysicalInventoryAdjustment(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createPhysicalInventoryAdjustment",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchPhysicalInventoriesAllBinLocation(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchPhysicalInventoriesAllBinLocation",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPhysicalInventoryAdjustmentPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPhysicalInventoryAdjustmentPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockPhysicalInventoryAdjustmentNumber(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "unLockPhysicalInventoryAdjustmentNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateExistingSkuBatchInventory(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateExistingSkuBatchInventory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createManualInventoryCustomerAllocation(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createManualInventoryCustomerAllocation",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static updateManualInventoryCustomerAllocation(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateManualInventoryCustomerAllocation",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuBatchHoldLocationInventoryPageList(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchHoldLocationInventoryPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateRollConventionSkuBatchInventory(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateRollConventionSkuBatchInventory",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getAvailableSKUBatchInventories(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getAvailableSKUBatchInventories",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSkuInventoryTrackPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getSkuInventoryTrackPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  
  static getAvailableSKUBatchInventoriesAllocatedForPickticket(input, responseCallBack, errorCallBack) {
    this.method(
      "getAvailableSKUBatchInventoriesAllocatedForPickticket",
      input,
      responseCallBack,
      errorCallBack
    );
  }  
  
  static getSkuBatchDetailsForPurchaseReceipt(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSkuBatchDetailsForPurchaseReceipt",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static createInventoryAdjustmentForSalesOrderSampleLines(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createInventoryAdjustmentForSalesOrderSampleLines",
      input,
      responseCallBack,
      errorCallBack
    );
  }

static getSKUBatchInventoriesForLotBasedSalesOrderDetails(input, responseCallBack, errorCallBack) {
    this.method(
      "getSKUBatchInventoriesForLotBasedSalesOrderDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }  
  
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // axios({
      //   method: "post",
      //   url: this.inv_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     "Content-Type": "application/json",
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
        ServiceExecutorProxy.executeService(methodName, input,this.inv_data_url,responseCallBack, errorCallBack);
    }
  }
}
